const QR_ADMITTED_PREFIX = 'rrms_qr_admitted_';
const QR_LOGIN_RETURN_KEY = 'rrms_qr_login_return';

export function setQrLoginReturn(path: string): void {
  sessionStorage.setItem(QR_LOGIN_RETURN_KEY, path);
}

export function peekQrLoginReturn(): string | null {
  return sessionStorage.getItem(QR_LOGIN_RETURN_KEY);
}

export function consumeQrLoginReturn(): string | null {
  const path = sessionStorage.getItem(QR_LOGIN_RETURN_KEY);
  sessionStorage.removeItem(QR_LOGIN_RETURN_KEY);
  return path;
}

/** Prefer router state; fall back to sessionStorage set by QR scan entry. */
export function resolvePostLoginRedirect(
  fromState?: string | null
): string {
  if (fromState) {
    sessionStorage.removeItem(QR_LOGIN_RETURN_KEY);
    return fromState;
  }
  return consumeQrLoginReturn() || '';
}

export function qrCaseViewPath(caseId: string): string {
  return `/qr/cases/${encodeURIComponent(caseId)}`;
}

export function qrScanPath(caseId: string): string {
  return `/qr/scan/${encodeURIComponent(caseId)}`;
}

export function qrAdmittedKey(caseId: string): string {
  return `${QR_ADMITTED_PREFIX}${caseId}`;
}

export function setQrAdmitted(caseId: string): void {
  sessionStorage.setItem(qrAdmittedKey(caseId), '1');
}

export function clearQrAdmitted(caseId: string): void {
  sessionStorage.removeItem(qrAdmittedKey(caseId));
}

export function isQrAdmitted(caseId: string): boolean {
  return sessionStorage.getItem(qrAdmittedKey(caseId)) === '1';
}

export function caseIdFromQrViewPath(path: string): string | null {
  const m = path.match(/^\/qr\/cases\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

/**
 * Called on successful login: resolves where to go next and, when that is a
 * QR case view, admits the case so CaseQRViewGate lets the user through.
 */
export function completeLoginRedirect(fromState?: string | null): string | null {
  const target = resolvePostLoginRedirect(fromState);
  if (!target) return null;
  const qrCaseId = caseIdFromQrViewPath(target);
  if (qrCaseId) setQrAdmitted(qrCaseId);
  return target;
}
